import { LocalStorageService } from 'src/features/authentication/utils/LocalStorageService';

const BILLING_INFORMATION_VIEWED_KEY = 'billingInformationViewed';

// Scoped per user and customer so a shared browser, or a billing admin of several accounts,
// doesn't skip the billing information page for an account they haven't seen it for.
const getStorageKey = (customerId: string, userId: string) =>
  `${BILLING_INFORMATION_VIEWED_KEY}_${customerId}_${userId}`;

export const hasViewedBillingInformation = (customerId: string, userId: string): boolean => {
  if (!customerId || !userId) return false;

  try {
    return LocalStorageService.getRaw(getStorageKey(customerId, userId)) === 'true';
  } catch {
    return false;
  }
};

export const markBillingInformationViewed = (customerId: string, userId: string) => {
  if (!customerId || !userId) return;

  LocalStorageService.set(getStorageKey(customerId, userId), 'true');
};
